import { QuizAnswer } from './quiz-answer';

export class EssayAnswer extends QuizAnswer {
    public correctFeedback: string;
    public incorrectFeedback: string;
    public incorrectComments: string;
    public correctComments: string;
    public neutralCommentsHtml: string;
    public answerText:string;
}